/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchSurveyLabelDto } from '../../models/search-survey-label-dto';

export interface SearchForSurveyLabel$Params {
  surveyLabel: string;
}

export function searchForSurveyLabel(
  http: HttpClient,
  rootUrl: string,
  params: SearchForSurveyLabel$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchSurveyLabelDto>> {
  const rb = new RequestBuilder(rootUrl, searchForSurveyLabel.PATH, 'get');
  if (params) {
    rb.path('surveyLabel', params.surveyLabel, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchSurveyLabelDto>;
      }),
    );
}

searchForSurveyLabel.PATH = '/search/survey-label/survey_label/{surveyLabel}';
